import FJTextToVideoScriptEdit from './FJTextToVideoScriptEdit';
import { useDispatch, useSelector } from 'react-redux';
import { useCallback, useMemo } from 'react';
import FJActionTextToVideo from '../../../redux/action/FJActionTextToVideo';
import useLocalStore from '../../../hooks/useLocalStore';
import FJAppConstant from '../../../constants/FJAppConstant';
import { setSliceTextToVideoStep } from '../../../redux/slices/FJSliceTextToVideo';
import FJConstant from '../../../constants/FJConstant';
import FJMessageStore from '../../../store/FJMessageStore';
import FJLocalStore from '../../../store/FJLocalStore';
import FJUtil from '../../../util/FJUtil';
const FJTextToVideoScriptEditContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();
    const sceneTextList = useSelector(state => state.textToVideo.sceneTextList);
    const selectTab = useSelector(state => state.textToVideo.selectTab);
    const textToVideoStepList = useSelector(state => state.textToVideo.textToVideoStepList);
    const updateSceneTextList = useCallback(
        (id, options) => {
            dispatch(FJActionTextToVideo.onUpdateSceneTextListAction(id, options));
        },
        [dispatch],
    );
    const _onEditNext = useCallback(() => {
        if (sceneTextList.length == 0 || sceneTextList.reduce((acc, item) => acc + item.text.trim(), '') === '') {
            FJMessageStore.addMessage(FJLocalStore._('please-enter-the-script-first'), 'error');
            return;
        }
        FJUtil.eaLog('text_to_full_video_script_next_click', {
            script_text: sceneTextList.map(item => item.text).join('\n'),
            mode: 'ai script mode',
            page: window.isEditPage ? 'editor' : 'tools page',
        });
        dispatch(setSliceTextToVideoStep(FJConstant.STEP_TYPE_VIDEO_SETTINGS));
    }, [dispatch, sceneTextList]);
    const isShowEditInput = useMemo(() => {
        return selectTab === FJAppConstant.TEXT_TO_FULL_VIDEO && textToVideoStepList.length === 3;
    }, [selectTab, textToVideoStepList]);
    return (
        <FJTextToVideoScriptEdit
            sceneTextList={sceneTextList}
            updateSceneTextList={updateSceneTextList}
            onEditNext={_onEditNext}
            isShowEditInput={isShowEditInput}
        />
    );
};

export default FJTextToVideoScriptEditContainer;
